import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class PlanningMessagesService {
  private base_url = `${environment.API_URL}/planning`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);
  constructor(private http: HttpClient) {}

  getPlanningMessages(planning_id: number) {
    return this.http
      .get(`${this.base_url}/${planning_id}/messages`, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  sendPlanningMessage(body: object) {
    return this.http.post(`${this.base_url}/message`, body, { headers: this.headers });
  }

  getPlanningUserUnreadMessages(planning_id: number) {
    return this.http
      .get(`${this.base_url}/${planning_id}/user-unread-messages`, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/planning-messages.service.ts